import { useFeatureAccessSettings } from '../featureAccessSettings';
import { useIsLeaderIDSmartEntryPointsEnabled } from '../leaderSettings';
import { useHasUserNetworkLeaders } from '../userNetworkLeaders';
import { useLoadAllLeaders } from '../userNetworkLeadersList';

import { useCanUserAccessLeadershipCornerWithoutLeaders } from './useCanUserAccessLeadershipCornerWithoutLeaders';

type UseCanUserAccessLeadershipCorner = () => boolean;
export const useCanUserAccessLeadershipCorner: UseCanUserAccessLeadershipCorner = () => {
  useLoadAllLeaders({ leadersCount: 1 });

  const featureAccessSettings = useFeatureAccessSettings();

  const isLeaderIDSmartEntryPointsEnabled = useIsLeaderIDSmartEntryPointsEnabled();
  const hasUserNetworkLeaders = useHasUserNetworkLeaders();
  const canUserAccessLeadershipCornerWithoutLeaders = useCanUserAccessLeadershipCornerWithoutLeaders();

  if (isLeaderIDSmartEntryPointsEnabled && !hasUserNetworkLeaders) {
    return canUserAccessLeadershipCornerWithoutLeaders;
  }

  return !!featureAccessSettings?.viewerCanAccessLeadershipCorner;
};
